import { cx } from '@linaria/core';
import { toggle, checkedModifier } from './switch.styles.js';
import { jsx } from 'react/jsx-runtime';

function Switch(props) {
  return /*#__PURE__*/jsx("input", {
    ...props,
    ref: props.ref,
    type: "checkbox",
    className: cx(toggle, props.className, props.checked && checkedModifier)
  });
}

export { Switch };
//# sourceMappingURL=switch.js.map
